export interface Dict<T> {
  readonly [key: string]: T;
}
export interface PaginationDTO {
  readonly data: [];
  readonly has_next_page?: boolean;
  readonly has_prev_page?: boolean;
  readonly per_page: number;
  readonly next_page?: number;
  readonly page: number;
  readonly paging_counter?: number;
  readonly prev_page?: number;
  readonly total_docs?: number;
  readonly total_pages?: number;
}

export interface FilterDTO {
  readonly data: [];
  readonly fields: FieldsDTO[];
  readonly has_next_page: boolean;
  readonly has_prev_page: boolean;
  readonly per_page: number;
  readonly next_page: number;
  readonly page: number;
  readonly paging_counter: number;
  readonly prev_page: number;
  readonly total_docs: number;
  readonly total_pages: number;
}

export interface FieldsDTO {
  readonly name: string;
  readonly facet?: boolean;
  readonly search?: boolean;
  readonly sort?: boolean;
  readonly title?: string;
  readonly type?: string;
}

export interface MainColumnsDTO {
  readonly Header: string;
  readonly accessor: string;
}

export interface MainDataDTO extends MainDataDTOWITHOUTDATA {
  readonly data: [];
}

export interface SelectDTO {
  readonly label: string;
  readonly value: string;
}

export interface MainDataDTOWITHOUTDATA {
  readonly fields: FieldsDTO[];
  readonly has_next_page: boolean;
  readonly has_prev_page: boolean;
  readonly per_page: number;
  readonly next_page: number;
  readonly page: number;
  readonly paging_counter: number;
  readonly prev_page: number;
  readonly total_docs: number;
  readonly total_pages: number;
}

export enum RolesEnum {
  StockmanDc = "STOCKMAN-DC",
  StockmanPup = "STOCKMAN-PUP",
  Loader = "LOADER",
  Chief = "CHEIF",
}
